import React from 'react';
import PlaceholderTab from './PlaceholderTab';

function PlanningTab() {
  return <PlaceholderTab tabName="Planning" />;
}

export default PlanningTab;
